import { memo } from 'react';
import { useStore } from '../store';
import EventModal from './EventModal';
const SoftwareEvent = () => {
  const busScenData = useStore((s) => s.busScenData);

  if (!busScenData || !busScenData.id) return null;

  return (
    <>
      {busScenData.id && <EventModal {...busScenData} />}
    </>
  );
};

export default memo(SoftwareEvent);